{
  "DatePicker": {
    "toggleIncludeHoursRich": "<p>Podaj dokładną godzinę początku i końca zakresu dat</p>Naciśnij <kbd>,</kbd>, aby przełączyć",
    "toggleIncludeHours": "Podaj godzinę początku i końca",
    "toggleIncludeHoursHint": "Naciśnij",
    "pressEnterToApply": "Naciśnij <kbd><enter/></kbd>, aby zastosować",
    "presetsLabel": "Zakresy dat",
    "presetsHeader": "Skróty",
    "range": {
      "lastWeek": "Ostatni tydzień",
      "currentWeek": "Bieżący tydzień",
      "lastMonth": "Ostatni miesiąc",
      "currentMonth": "Bieżący miesiąc",
      "last3Months": "Ostatni kwartał",
      "current3Months": "Bieżący kwartał",
      "lastYear": "Ostatni rok",
      "currentYear": "Bieżący rok",
      "allTime": "Cały czas"
    }
  },
  "Select": {
    "clear": "Wyczyść",
    "emptyPlaceholder": "Wybierz…"
  },
  "TernaryToggle": {
    "yes": "Tak",
    "no": "Nie",
    "notSet": "Nie ustawiono",
    "emptyValue": "n/d"
  },
  "Pagination": {
    "page": "Strona {{current}} / {{total}}",
    "pageFraction": "{{current}} / {{total}}",
    "navigation": "Paginacja",
    "previousPage": "Poprzednia strona",
    "nextPage": "Następna strona",
    "jumpInput": "Numer strony",
    "jumpPlaceholder": "1 - {{total}}",
    "jumpAction": "Przejdź"
  }
}
